import React, {useEffect, useState} from 'react';
import {toAbsoluteUrl} from "../../../../../_metronic/helpers";

import clsx from "clsx";
import {Link, useParams, useSearchParams} from "react-router-dom";

const Callback = () => {
    const params = useParams();
    let [searchParams] = useSearchParams();

    useEffect(()=>{
       console.log(searchParams.get('status'))
    },[])
    useEffect(() => {
        document.body.style.backgroundImage = 'none'
        return () => {}
    }, [])
    return (
        <div
            className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
            style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
            }}
        >
            {/* begin::Content */}
            <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
                {/* begin::Logo */}
                <a href='#' className='mb-12'>
                    <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                        className='theme-dark-show h-45px'
                    />
                    <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/logos/default.svg')}
                        className='theme-light-show h-45px'
                    ></img>
                </a>
                {/* end::Logo */}
                {/* begin::Wrapper */}
                <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>




                    <div className="w-100">
                        {/* begin::Heading */}
                        <div className='text-center mb-10'>
                            <h1 className='text-dark mb-3'> پرداخت</h1>
                        </div>
                        {/* begin::Heading */}
                        {searchParams.get('status')!=null && searchParams.get('status')?.toLowerCase() == 'ok'?(
                            <>
                                <div className='mb-lg-15 alert alert-success'>
                                    <div className='alert-text font-weight-bold'>{searchParams.get('message')} </div>
                                </div>
                                {/* begin::Form group */}
                                <div className='fv-row mb-10 row'>
                                    <label className='col-lg-4 fw-semibold text-muted'>کد رهگیری </label>
                                    <div className='col-lg-8 d-flex align-items-center'>
                                        <span className='fw-bold fs-6 me-2'>{searchParams.get('refNumber')}</span>
                                    </div>
                                </div>
                                <div className='fv-row mb-10 row'>
                                    <label className='col-lg-4 fw-semibold text-muted'>مبلغ  </label>
                                    <div className='col-lg-8 d-flex align-items-center'>
                                        <span className='fw-bold fs-6 me-2'>{searchParams.get('amount')?.toLocaleLowerCase()}</span>
                                    </div>
                                </div>

                                {/* end::Form group */}
                            </>
                        ):(
                            <div className='mb-lg-15 alert alert-danger'>
                                <div className='alert-text font-weight-bold'>{searchParams.get('message')} </div>
                            </div>
                        ) }
                        <div className='card-footer d-flex justify-content-end py-6 px-9'>
                            <Link className='btn btn-primary' to="/crafted/account/overview">تایید</Link>

                        </div>


                    </div>

                </div>
                {/* end::Wrapper */}
            </div>
            {/* end::Content */}
            {/* begin::Footer */}
            <div className='d-flex flex-center flex-column-auto p-10'>
                <div className='d-flex align-items-center fw-semibold fs-6'>
                    <a href='#' className='text-muted text-hover-primary px-2'>
                        About
                    </a>

                    <a href='#' className='text-muted text-hover-primary px-2'>
                        Contact
                    </a>

                    <a href='#' className='text-muted text-hover-primary px-2'>
                        Contact Us
                    </a>
                </div>
            </div>
            {/* end::Footer */}
        </div>
    );
};
export default Callback ;



